<template>
  <div class="good-detail-box taobao-detail-box">
    <van-nav-bar title="淘宝/天猫 商品详情" fixed left-arrow @click-left="$router.go(-1)" />
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <div
          class="good-img"
          :style="{ 'background-image': 'url(' + image + ')' }"
        ></div>
      </van-swipe-item>
    </van-swipe>

    <div class="good-body">
      <div class="price-content">
        <div class="coupon-price">券后价：￥<span class="price">{{ price }}</span></div>
        <div class="original-price">原价:￥{{goodInfo.zk_final_price}}</div>
        <div class="volume">
          已售 <span class="c-red">{{ goodInfo.volume }}</span> 件
        </div>
      </div>
      <div class="name-content">
        <van-tag type="warning" v-if="goodInfo.user_type === 1">天猫</van-tag>
        <van-tag type="warning" v-else>淘宝</van-tag>
        <span class="name">
          {{ goodInfo.title }}
        </span>
      </div>
      <!-- <div class="coupon-content">
        <van-tag plain size="large" type="danger">5元券剩余4000张</van-tag>
      </div> -->
      <!-- <div class="commission-content">
        <van-icon name="after-sale" /> 当前佣金
        <span class="commission">￥100 </span> 元
      </div> -->
      <div class="info">{{goodInfo.kuadian_promotion_info}}<br/>{{ goodInfo.play_info }}</div>
    </div>
    <div style="height: 55px"></div>
    <van-goods-action>
      <van-goods-action-icon
        icon="shop-o"
        text="首页"
        @click="$router.push('/')"
      />
      <!-- <van-goods-action-button
        type="warning"
        :text="`分享赚 ${promotion_rate} 元`"
        @click="doCopy"
      />
        <van-goods-action-button
        type="danger"
        :text="`立即买省 ${promotion_rate} 元`"
        @click="doCopy"
      /> -->
      <van-goods-action-button
        type="warning"
        text="分享"
        @click="doCopy"
      />
      <van-goods-action-button
        type="danger"
        text="立即买"
        @click="doCopy"
      />
    </van-goods-action>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      goodInfo: {}, //商品详情
      images: [], //轮播图
    };
  },
   computed: {
    ...mapState(["rate"]),
     // 券后价
    price(){
       return Number((this.goodInfo.zk_final_price - this.goodInfo.coupon_amount).toFixed(2));
    },
    // 佣金折算
    promotion_rate() {
      return (
        ((Number(this.goodInfo.commission_rate) / 1000) *
          this.price *
          this.rate) /
        100
      ).toFixed(2);
    },
  },
  created() {
    const goodInfo = JSON.parse(window.localStorage.getItem("goodInfo")) || {};
    this.Post({ id: this.$route.query.id }, "/taobao/getItemInfo", (res) => {
      if (res.states == 1) {
        let Data = res.data.results.n_tbk_item;
        if(Data.num_iid === goodInfo.item_id){
            Data = {
              ...Data,
              ...goodInfo,
            }
        }
        this.goodInfo = Data;
        this.images = Data.small_images.string;
      }
    });
  },
  methods: {
    // 复制淘口令
    doCopy() {
      let url = "https:" + this.goodInfo.coupon_share_url;
      if (this.goodInfo.coupon_share_url == undefined) {
        url = this.goodInfo.coupon_click_url;
      }
      this.Post(
        {
          text: this.goodInfo.title,
          url: url,
          logo: this.goodInfo.pict_url,
        },
        "/taobao/createTpwd",
        (res) => {
          if (res.states == 1) {
            let model = res.data.data.model;
            this.$router.push("/taobao/share?code=" + model);
          }
        }
      );
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '../../assets/less/good.less';
</style>



// WEBPACK FOOTER //
// src/pages/taobao/detail.vue